{
	"title": "Open source-programvaruattribuering",
	"backTitle": "Tillbaka"
}
